import { FC, useMemo } from 'react';

import { LOOKBOOK_ROUTE_PATH } from '../Root/router/constants.ts';
import { getWithOutSpecialChars } from '../Root/utils';
import { useResize } from '../Root/hooks';
import InterestCarousel from '../Root/components/InterestCarousel/InterestCarousel';
import SingleCard from '../Root/pages/HomeRoot/components/SingleCard/SingleCard';
import { getSSRTranslation } from '../../i18n';
import NotFoundTemplate from '../../components/NotFoundTemplate';

import './index.scss';
import { useQuery } from '@tanstack/react-query';
import {
  fetchNotFoundRoute,
  NOT_FOUND_QUERY_KEY,
} from '@moment/net/classic-fotoscapes/fetch-not-found-route.ts';
import { useTranslation } from 'react-i18next';

const NotFoundPage: FC = () => {
  const { isMobile } = useResize();

  const { i18n } = useTranslation();
  const lang = i18n.language;

  const fetchFn = useMemo(() => {
    return fetchNotFoundRoute({lang})
  }, [lang])

  const { data } = useQuery({
    queryKey: [lang, NOT_FOUND_QUERY_KEY],
    queryFn: fetchFn,
  });

  const latestList = useMemo(() => {
    return data?.items || [];
  }, [data]);

  return (
    <div className="not-found-page">
      <NotFoundTemplate />
      <div className="not-found-page__carousel-wrapper">
        <h3 className="not-found-page__carousel-title">
          Take Time to Explore...
        </h3>

        <div className="not-found-page__interest-content">
          <InterestCarousel
            isSmallView={true}
            isMobile={isMobile}
            itemList={latestList}
            renderItem={({ images, title, brandLogo, uid, interests }) => {
              return (
                <SingleCard
                  uid={uid}
                  interestId={interests[0]}
                  classList="interest-carousel__cover-look"
                  title={getSSRTranslation(title, i18n)}
                  imgList={images}
                  logoURL={brandLogo}
                  link={LOOKBOOK_ROUTE_PATH?.replace(':lookbookId', uid).replace(
                    ':title?',
                    getWithOutSpecialChars(title?.en)
                  )}
                />
              );
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
